<div class="space-y-4 p-6 max-h-[85vh] overflow-y-auto">
    <div class="flex justify-between items-center">
        <div class="flex items-center space-x-2">
            <div class="flex font-medium text-primary-400 gap-2">
                <div class="">
                    <img src="assets/svg/hierarchy.svg" alt="" class="w-5">
                </div>
                <div class="">แก้ไขราคาเซ็ต (พร้อมอัพเดตเซ็ตร่วม)</div>
            </div>
        </div>
    </div>

    <form [formGroup]="form" (ngSubmit)="submit()" class="grid grid-cols-4 gap-4">
        <div formArrayName="products" class="card col-span-full space-y-10">
            <div class="div-table">
                <table>
                    <thead>
                        <tr class="thead-tr">
                            <th class="text-left">สินค้า</th>
                            <th class="text-center w-24">จำนวนชิ้น</th>
                            <th class="text-right">ทุน(เฉลี่ยก่อนVat)</th>
                            <th class="text-right">ทุน+{{percent}}%</th>
                            <th class="text-right">ทุนรวม</th>
                            <th class="text-center w-32">ราคาขาย</th>
                            <th class="text-center w-32">ราคา SRP/ชิ้น</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let product of products.controls; let i = index" [formGroupName]="i"
                            class="tbody-tr">
                            <td>
                                <div class="flex items-center gap-2">
                                    <img [src]="'https://storage.maxxgadget.com/img/product/' + product.get('sku')?.value + '/1.jpg'"
                                        alt="" class="w-10 h-10"
                                        onerror="this.onerror=null; this.src='assets/images/warranty.png'">
                                    <div class="flex-wrap min-w-44">
                                        <div class="truncate w-60">{{ product.get('name')?.value }}</div>
                                        <div class="text-primary-500">{{ product.get('sku')?.value }}</div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center">
                                {{ product.get('qty')?.value | number }}
                            </td>
                            <td class="text-right">{{ product.get('cost')?.value | number }}</td>
                            <td class="text-right">{{ product.get('cost_added')?.value | number }}</td>
                            <td class="text-right">{{ (product.get('cost_added')?.value * product.get('qty')?.value) |
                                number }}</td>
                            <td class="text-right">
                                <div class="w-32">
                                    <input type="number" formControlName="price" class="input" autocomplete="off"
                                        [ngClass]="{'input-invalid': ((product.get('cost_added')?.value * product.get('qty')?.value) > product.get('price')?.value) }">
                                    <div *ngIf=" ((product.get('cost_added')?.value * product.get('qty')?.value) > product.get('price')?.value) && !product.get('price')?.invalid && product.get('price')?.touched"
                                        class="error-message">
                                        ควรมากกว่าทุนรวม
                                    </div>
                                    <div *ngIf="product.get('price')?.invalid && product.get('price')?.touched"
                                        class="error-message">
                                        จำนวนขั้นต่ำ 0
                                    </div>
                                </div>
                            </td>
                            <td class="text-right">
                                <div class="w-32">
                                    <input type="number" formControlName="srp_price" class="input" autocomplete="off"
                                        [ngClass]="{'input-invalid': ((product.get('srp_price')?.value) <= (product.get('price')?.value / product.get('qty')?.value)) }">
                                    <div *ngIf=" ((product.get('srp_price')?.value) <= (product.get('price')?.value / product.get('qty')?.value)) && !product.get('srp_price')?.invalid && product.get('srp_price')?.touched"
                                        class="error-message">
                                        ควรมากกว่าราคาขาย/ชิ้น
                                    </div>
                                    <div *ngIf="product.get('srp_price')?.invalid && product.get('srp_price')?.touched"
                                        class="error-message">
                                        จำนวนขั้นต่ำ 0
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="w-full grid grid-cols-4 gap-4 border-t border-dashed pt-6">
                <div>
                    <div>จำนวนสินค้า</div>
                    <input class="input" [value]="summaryItem()" disabled />
                </div>
                <div>
                    <div>ราคา SRP</div>
                    <input class="input" [value]="summarySRP()" disabled />
                </div>
                <div>
                    <div>ราคาเซ็ต</div>
                    <input class="input" [value]="summaryPrice()" disabled />
                </div>
                <div>
                    <div>ทุนรวมเซ็ต</div>
                    <input class="input" [value]="summaryCostAdded()" disabled />
                </div>
            </div>
        </div>
    </form>

    <div class="card col-span-full space-y-6">
        <div class="font-medium text-primary-400">เซ็ตร่วมของแต่ละ SKU</div>

        <div *ngFor="let product of products.controls" class="space-y-2">
            <div class="flex items-center justify-between border-b pb-2">
                <div class="font-medium">
                    เซ็ตร่วมของ
                    <span class="text-primary-500">{{ product.get('sku')?.value }}</span>
                    <span class="text-gray-500"> — {{ product.get('name')?.value }}</span>
                </div>
                <button type="button" class="btn-sm btn-primary"
                    [disabled]="countSelectedRelated(product.get('sku')?.value) === 0 || product.get('price')?.invalid || product.get('srp_price')?.invalid"
                    (click)="propagatePriceToRelated(product.get('sku')?.value)">
                    อัพเดตราคาเดียวกันทั้งหมด ({{ countSelectedRelated(product.get('sku')?.value) }})
                </button>
            </div>

            <div *ngIf="loadingBySku[product.get('sku')?.value]" class="text-sm text-gray-500 py-2">
                กำลังโหลดเซ็ตร่วม...
            </div>

            <div *ngIf="!loadingBySku[product.get('sku')?.value] && (relatedSetsBySku[product.get('sku')?.value]?.length ?? 0) === 0"
                class="text-sm text-gray-500 py-2">
                ไม่พบเซ็ตร่วม
            </div>

            <div class="div-table"
                *ngIf="!loadingBySku[product.get('sku')?.value] && (relatedSetsBySku[product.get('sku')?.value]?.length ?? 0) > 0">
                <table>
                    <thead>
                        <tr class="thead-tr">
                            <th class="text-center w-10">
                                <input type="checkbox"
                                    [checked]="isAllRelatedSelected(product.get('sku')?.value)"
                                    (change)="toggleSelectAllRelated(product.get('sku')?.value, $any($event.target).checked)">
                            </th>
                            <th class="text-left">SET</th>
                            <th class="text-center w-24">จำนวน</th>
                            <th class="text-right">ราคาขาย</th>
                            <th class="text-right">SRP/ชิ้น</th>
                            <th class="text-right">SRP รวม</th>
                            <th class="text-right">ราคาเซ็ตรวม</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let related of relatedSetsBySku[product.get('sku')?.value]" class="tbody-tr">
                            <td class="text-center">
                                <input type="checkbox" [(ngModel)]="related.selected"
                                    [ngModelOptions]="{standalone: true}">
                            </td>
                            <td class="text-left">
                                <div class="font-semibold text-primary-500">{{ related.set_sku }}</div>
                                <div class="text-gray-500 text-sm">{{ related.name }}</div>
                            </td>
                            <td class="text-center">{{ related.qty | number }}</td>
                            <td class="text-right">
                                <ng-container
                                    *ngIf="previewLinePrice(related, product.get('sku')?.value) as newLine; else priceOnly">
                                    <ng-container *ngIf="newLine !== related.price; else priceOnly">
                                        <div class="text-gray-400 line-through text-xs">{{ related.price | number }}
                                        </div>
                                        <div class="text-primary-500 font-semibold">{{ newLine | number }}</div>
                                    </ng-container>
                                </ng-container>
                                <ng-template #priceOnly>
                                    <div>{{ related.price | number }}</div>
                                </ng-template>
                            </td>
                            <td class="text-right">
                                <ng-container
                                    *ngIf="previewSrp(product.get('sku')?.value) as newSrp; else srpOnly">
                                    <ng-container *ngIf="newSrp !== related.srp_price; else srpOnly">
                                        <div class="text-gray-400 line-through text-xs">{{ related.srp_price | number }}
                                        </div>
                                        <div class="text-primary-500 font-semibold">{{ newSrp | number }}</div>
                                    </ng-container>
                                </ng-container>
                                <ng-template #srpOnly>
                                    <div>{{ related.srp_price | number }}</div>
                                </ng-template>
                            </td>
                            <td class="text-right">
                                <ng-container
                                    *ngIf="previewTotalSrp(related, product.get('sku')?.value) as newTotalSrp; else totalSrpOnly">
                                    <ng-container *ngIf="newTotalSrp !== related.total_srp; else totalSrpOnly">
                                        <div class="text-gray-400 line-through text-xs">{{ related.total_srp | number }}
                                        </div>
                                        <div class="text-primary-500 font-semibold">{{ newTotalSrp | number }}</div>
                                    </ng-container>
                                </ng-container>
                                <ng-template #totalSrpOnly>
                                    <div>{{ related.total_srp | number }}</div>
                                </ng-template>
                            </td>
                            <td class="text-right">
                                <ng-container
                                    *ngIf="previewTotal(related, product.get('sku')?.value) as newTotal; else totalOnly">
                                    <ng-container *ngIf="newTotal !== related.total_price; else totalOnly">
                                        <div class="text-gray-400 line-through text-xs">{{ related.total_price | number
                                            }}</div>
                                        <div class="text-primary-500 font-semibold">{{ newTotal | number }}</div>
                                    </ng-container>
                                </ng-container>
                                <ng-template #totalOnly>
                                    <div>{{ related.total_price | number }}</div>
                                </ng-template>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div class="flex justify-center space-x-2">
        <button class="btn-sm btn-light w-32" type="button" (click)="cancel()">ยกเลิก</button>
        <button class="btn-sm btn-primary w-32" type="button" [disabled]="form.invalid"
            (click)="submit()">บันทึกข้อมูล</button>
    </div>
</div>
